import React, { useState, useEffect } from 'react';
import './login.css';
import logo from '../../Assets/logo.png'; 
import TermsModal from '../Login/termsModal';
import { useAuth } from '../../Components/Contexts/authContext';
import { useNavigate,Link } from 'react-router-dom';

const Login = () => {
  const [documento, setDocumento] = useState('');
  const [password, setPassword] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar el modal
  const [errorMessage, setErrorMessage] = useState('');
  const { login} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage('');
      }, 5000); // 5000 ms = 5 segundos

      return () => clearTimeout(timer); 
    }
  }, [errorMessage]);

  /*useEffect(() => {
    const termsAccepted = localStorage.getItem('termsAccepted') === 'true';
    setShowTerms(!termsAccepted);
    setAcceptedTerms(termsAccepted);
  }, []);*/

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!documento || !password) {
      setErrorMessage('Por favor complete los campos');
      return;
    }

    if (!acceptedTerms) {
      setErrorMessage('Debes aceptar los términos y condiciones para continuar');
      return;
    }
  
    const document = documento;
    const pass = password;
  
    setErrorMessage('');
  
    try {
      const response = await fetch('https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          ci: document, 
          password: pass 
        }),
      });
      console.log(response)
      if (response.ok) {
        const data = await response.json();
        const token = data.token;
        const role = data.role;
        login(token, role);
        localStorage.setItem('employeeId', data.ci);
        localStorage.setItem('role', data.role);
        if(data.role === 'admin'){
          navigate('/register');
        }else {
          navigate('/main');
        }
      } else {
        setErrorMessage('Usuario o contraseña incorrectos');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('Error en la conexión con el servidor');
    }
  
    //localStorage.setItem('termsAccepted', 'true');
  };  

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="login-container">
      <img src={logo} alt="EasyPay Logo" className="login-logo" />
      <h2 className="login-title font-bold">Iniciar Sesión</h2>
      <p className="welcome-message font-bold">¡Bienvenido de vuelta!</p>
      <form className="login-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Documento"
          className="login-input"
          value={documento}
          onChange={(e) => setDocumento(e.target.value)}
        />
        <input
          type="password"
          placeholder="Contraseña"
          className="login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit" className="login-button">
          Iniciar Sesion
        </button>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {showTerms && (
          <div className="terms-container">
            <input
              type="checkbox"
              id="terms"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <label htmlFor="terms">
              Acepto los <span className="terms-link" onClick={openModal}>términos y condiciones</span>
            </label>
          </div>
        )}
      </form>
      <div className="help-links">
        <a href="#">¿Necesitas ayuda?</a>
        <a href="/reset-password">¿Olvidaste tu contraseña?</a>
      </div>
      <TermsModal isOpen={isModalOpen} onClose={closeModal} /> {/* Renderiza el modal */}
    </div>
  );
};

export default Login;

